module.exports = __webpack_public_path__ + "img/9months.8295a864.svg";